import { useMemo } from 'react';
import { useUser } from '@shared/hooks';

export const useProgramAuthor = (authorId?: number) => {
  const { user } = useUser();

  const isAuthor = useMemo(() => {
    return user?.id === authorId;
  }, [user, authorId]);

  return {
    isAuthor,
  };
};
